<template>
    <div>
        <div class="app-title">
            <em-view-title ref="emViewTitle" v-bind:crudState="$_emWorkflowTaskMixin_pathType"></em-view-title>
        </div>
        <section class="app-content">
            <div id="entity-viewer" class="content" v-menu-permission="'list'">
                <div class="card">
                    <div id="collapseOne" class="collapse show" aria-labelledby="headingOne"
                         data-parent="#accordionFilter">
                        <div class="card-body">
                            <em-workflow-business-data-editor :entity="modelName"
                                                              :business-data="$_emWorkflowTaskMixin_businessData">
                            </em-workflow-business-data-editor>
                        </div>
                    </div>
                </div>
            </div>
            <div style="margin-top: 5px;padding: 1px;">
                <el-table :data="applyDetailTableData" :header-cell-style="{ background: '#99CC66',color: '#000000' }">
                    <el-table-column label="领用物品类别" prop="itemTypeName"></el-table-column>
                    <el-table-column label="领用物品名称" prop="itemName"></el-table-column>
                    <el-table-column label="领用物品型号" prop="itemModel"></el-table-column>
                    <el-table-column label="库存数量" prop="originalQuantity"></el-table-column>
                    <el-table-column label="领用数量" prop="applyQuantity"></el-table-column>
                    <el-table-column label="单位" prop="itemUnit"></el-table-column>
                    <!--                    <el-table-column label="备注" prop="remark"></el-table-column>-->
                </el-table>
            </div>
            <WorkflowProcessLine :processDefinitionKey="$_emWorkflowTaskMixin_processDefinitionKey"
                                 :config="config"
                                 ref="processExecution"
                                 @gotItems="setLocalVariables"
                                 :businessKey="$_emWorkflowTaskMixin_businessKey">
            </WorkflowProcessLine>
            <div id="em-workflow-task-complete" class="content" v-if="$_emWorkflowTaskMixin_isShowTaskComplete">
                <WorkflowTaskComplete ref="processComplete" :task-id="$_emWorkflowTaskMixin_taskId"
                                      :businessKey="$_emWorkflowTaskMixin_businessKey"
                                      :status="$_emWorkflowTaskMixin_businessData.status"
                                      :callbackApi="$_emWorkflowTaskMixin_callbackApi"
                                      :config="config">
                </WorkflowTaskComplete>
            </div>
        </section>
    </div>
</template>
<script>
// Author THQ
// Date 2025-03-05 00:04:55

import emWorkflowTaskMixin from "@/mixin/em/workflow/task";
import workflowTaskMixins from "@/components/workflow/mixin/WorkflowTaskMixins";
import WorkflowTaskComplete from "@/components/workflow/stuffs/WorkflowTaskComplete.vue";
import WorkflowProcessLine from "@/components/workflow/stuffs/WorkflowProcessLine.vue";
import emApiMixin from "@/mixin/em/common/api";

export default {
    name: "ppeApplyRecordWorkflowTaskView",
    components: {WorkflowProcessLine, WorkflowTaskComplete},
    mixins: [emWorkflowTaskMixin, workflowTaskMixins, emApiMixin],
    data() {
        return {
            applyDetailTableData: []
        }
    },
    computed: {
        modelName() {
            return this.$_emRouterHelperMixin_entityName
        },
        // materialNumbersDetailFields() {
        //     return [
        //         {
        //             key: 'materialNumber',
        //             label: '物料编码',
        //             type: this.VALUE_TYPE.SELECT,
        //             // optionFrom: {
        //             //     entity: 'sithMesInventoryOutdoorProductCategory',
        //             //     value: 'id',
        //             //     name: 'name'
        //             // }
        //             // options: [
        //             //     {value: 1, text: '提交'},
        //             //     {value: 2, text: '取消'},
        //             //     {value: 3, text: '补充信息'},
        //             // ],
        //         },
        //         {
        //             key: 'quantity',
        //             label: '数量',
        //             format: 'number'
        //         },
        //     ]
        // },
        config() {
            return {
                'task1': {
                    name: '申请PPE领用',
                    variables: [
                        {
                            label: '发起领用流程：',
                            type: this.VALUE_TYPE.SELECT,
                            saveTo: this.SAVE_TO.APPROVE,
                            options: [
                                {value: 1, text: '发起领用'},
                                {value: 2, text: '结束领用'}
                            ],
                        },
                        {
                            label: '备注',
                            name: 'comment',
                            type: this.VALUE_TYPE.TEXTAREA,
                            saveTo: this.SAVE_TO.FLOW,
                            initData: true,
                        }
                    ],
                    approveToNextTask: {
                        1: 'task2',
                        2: 'end_cancel'
                    },
                    changeTag: (_, approve) => {
                        return this.buildTag('needApprove', approve === 1);
                    },
                    withAttachment: true,
                    //withComment: true,
                    postByApprove: (approve) => {
                        return {
                            // 更新领用日期
                            url: this.$store.state.ppeApplyRecord.baseModuleUrl + `/ppeApplyRecord/updateApplyDate?flowId=${this.$_emWorkflowTaskMixin_businessKey}&approvedStatus=${approve}`,
                            data: {}
                        };
                    },
                },
                'task2': {
                    name: '领用员工部门经理审批',
                    variables: [
                        {
                            label: '领用审批结果：',
                            type: this.VALUE_TYPE.SELECT,
                            saveTo: this.SAVE_TO.APPROVE,
                            options: [
                                {value: 1, text: '审批通过'},
                                {value: 2, text: '审批退回'}
                            ],
                            require: true,
                        },
                        {
                            label: '备注',
                            name: 'comment',
                            type: this.VALUE_TYPE.TEXTAREA,
                            saveTo: this.SAVE_TO.FLOW,
                            initData: true,
                        }
                    ],
                    approveToNextTask: {
                        1: 'task3',
                        2: 'task1'
                    },
                    withAttachment: true,
                    //withComment: true,
                    postByApprove: (approve) => {
                        return {
                            url: this.$store.state.ppeApplyRecord.baseModuleUrl + `/ppeApplyRecord/doAfterTaskCommit?flowId=${this.$_emWorkflowTaskMixin_businessKey}&approvedStatus=${approve}`,
                            data: {}
                        };
                    },
                },
                'task3': {
                    name: 'PPE主管审核领用',
                    variables: [
                        {
                            label: '领用审核结果：',
                            type: this.VALUE_TYPE.SELECT,
                            saveTo: this.SAVE_TO.APPROVE,
                            options: [
                                {value: 1, text: '审核通过'},
                                {value: 2, text: '审核退回'}
                            ],
                            require: true,
                        },
                        {
                            label: '备注',
                            name: 'comment',
                            type: this.VALUE_TYPE.TEXTAREA,
                            saveTo: this.SAVE_TO.FLOW,
                            initData: true,
                        }
                    ],
                    approveToNextTask: {
                        1: 'task4',
                        2: 'task1'
                    },
                    withAttachment: true,
                    //withComment: true,
                    postByApprove: (approve) => {
                        return {
                            url: this.$store.state.ppeApplyRecord.baseModuleUrl + `/ppeApplyRecord/doAfterTaskCommit?flowId=${this.$_emWorkflowTaskMixin_businessKey}&approvedStatus=${approve}`,
                            data: {}
                        };
                    },
                },
                'task4': {
                    name: '库管员出库',
                    variables: [
                        {
                            label: '领用出库结果：',
                            type: this.VALUE_TYPE.SELECT,
                            saveTo: this.SAVE_TO.APPROVE,
                            options: [
                                {value: 1, text: '领用完成'},
                                {value: 2, text: '领用退回'}
                            ],
                        },
                        {
                            label: '备注',
                            name: 'comment',
                            type: this.VALUE_TYPE.TEXTAREA,
                            saveTo: this.SAVE_TO.FLOW,
                            initData: true,
                        }
                    ],
                    approveToNextTask: {
                        1: 'end_finish',
                        2: 'task1'
                    },
                    withAttachment: true,
                    //withComment: true
                    postByApprove: (approve) => {
                        return {
                            url: this.$store.state.ppeApplyRecord.baseModuleUrl + `/ppeApplyRecord/doAfterTaskFinish?flowId=${this.$_emWorkflowTaskMixin_businessKey}&approvedStatus=${approve}`,
                            data: {}
                        };
                    },
                },
                'EndEvent': {
                    name: '结束'
                }
            }
        }
    },
    methods: {
        queryApplyDetail() {
            this.$store.dispatch("api/post", {
                url: this.$store.state.ppeApplyRecord.baseModuleUrl + '/ppeApplyRecordDetail/findByFilter',
                data: {
                    flowIdFilter: this.$_emWorkflowTaskMixin_businessKey
                }
            }).then(res => {
                this.applyDetailTableData = res.data.list
            })
        }
    },
    mounted() {
        this.queryApplyDetail();
    }
};
</script>